module.exports = __webpack_public_path__ + "9dd28675da7a41aa2ab6360c60755a0f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/cape-stars-s.png
// module id = 1865
// module chunks = 0